import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustCards from './components/TrustCards';
import CategorySection from './components/CategorySection';
import SpreadsheetSection from './components/SpreadsheetSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import ContentSection from './components/ContentSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Spreadsheet Polska',
  url: import.meta.env.VITE_SITE_URL + '/',
  description: 'Najlepsza baza produktów Kakobuy — listy, linki i poradniki zakupowe dla polskich klientów.',
  inLanguage: 'pl',
  potentialAction: {
    '@type': 'SearchAction',
    target: import.meta.env.VITE_SITE_URL + '/?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <Hero />
      <TrustCards />
      <CategorySection />
      <SpreadsheetSection />
      <ComparisonSection />
      <SafetySection />
      <ContentSection />
      <FAQSection />
      <Footer />
    </main>
  );
}